import { Component, EventEmitter, Output } from '@angular/core';
import { ValidationResult, ValidationType } from 'libs/abc/ui-components/src/lib/core/src/abc-grid/abc-grid';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AbcExpressionsEditorService } from '../../expressions-editor.service';
import { ValidationTranslation } from '../../models/view.model';
import { OPathValidationService } from '../../services/oPath-validation.service';
import { SharedService } from '../../services/shared.service';

@Component({
  selector: 'expressions-editor-validate',
  templateUrl: './validate.component.html',
  styleUrls: ['./validate.component.scss'],
})
export class ValidateComponent {
  @Output() onStartOPathValidation: EventEmitter<void> = new EventEmitter();
  public ValidationType = ValidationType;
  public validationType: ValidationType = null;
  public translation: ValidationTranslation;
  public validationResult: ValidationResult = undefined;
  public loadingValidation: boolean = false;
  private unsubscribe$: Subject<void> = new Subject<void>();

  constructor(
    private abcExpressionOpathService: AbcExpressionsEditorService,
    private sharedService: SharedService,
    private validationService: OPathValidationService
  ) {
    this.translation = this.sharedService.translation.validation;
  }
  async ngOnInit(): Promise<void> {
    this.validationType = this.validationService.validationType;

    this.abcExpressionOpathService.onValidationResult.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {
      this.validationResult = value;
      this.loadingValidation = false;
    });
  }
  public ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  public executeValidation(): void {
    this.loadingValidation = true;
    this.onStartOPathValidation.emit();
  }
}
